import { useEffect } from "react";
import Image from "next/image";

const BannerClient = ({ ...props }) => {

	useEffect(() => {
		try {
			reviveAsync['0cceecb9cae9f51a31123c541910d59b'].refresh()
		} catch (e) {
			if (process.env.NODE_ENV !== 'production') {
				console.log('Error: ', e)
			}
		}
		try {
			if (
				props.dataAds &&
				props.dataAds !== ' ' &&
				typeof refreshSlotDfp === 'function'
			) {
				refreshSlotDfp(props.name)
			}
		} catch (e) {
			if (process.env.NODE_ENV !== 'production') {
				console.error('error refreshSlotDfp: ', e)
			}
		}
	})

	return (
    <>
      {props.dataAds && !props.isLoading ? (
				<div
        id={props.component_id}
        className={props.class_name || ''}
        dangerouslySetInnerHTML={{
          __html: props.dataAds,
        }}
      />
			) : (
				<div style={{
					width: "100%",
					height: "fit-content",
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					overflow: 'hidden',
				}}>
					<div
						className={props.class_name || ''}
						style={{ 
							position: 'relative',
							width: '100%',
							minHeight: props.is_mobile ? '100px' : '250px',
						}}
					>
						<Image
							src={`https://image.femaledaily.com/web-assets/ads/${props.placeholder}.png`}
							alt="banner-detik"
							layout="fill"
							objectFit="contain"
							priority={true}
							quality={70}
						/>
					</div>
				</div>
				)}

      <style jsx>
        {`
					.ads-medium-rectangle1 {
            display: flex;
            justify-content: center;
            min-height: 250px;
            width: 300px;
          }
          .ads-mediumrectangle2-detail {
            display: flex;
            justify-content: center;
            margin: 0 0 24px 0;
            min-height: 250px;
            width: 300px;
          }
					.ads-medium-rectangle2{
						display: flex;
            justify-content: center;
            min-height: 250px;
						height: 250px;
            width: 300px;
					}
          .ads-mediumrectangle3 {
            display: flex;
            justify-content: center;
            min-height: 250px;
            width: 300px;
          }
          .bottomframe {
            bottom: -4px;
            left: 0px;
            position: fixed;
            right: 0px;
            text-align: center;
            z-index: 3;
            min-height: 50px;
            width: 100%;
          }
          .ads-billboard {
            padding: 20px 0;
            min-height: ${props.is_mobile ? '100px' : '250px'};
            height: ${props.is_mobile ? '100px' : '250px'};
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: ${props.is_mobile ? '0px' : '66px'};
          }
          .horizontal-home {
            margin: 16px 0 20px 0;
          }
          .banner-1-mobile {
            text-align: center;
          }
          .mobile-staticbanner2 {
            margin-top: 16px;
          }
          .ads-static-3 {
            text-align: center;
            margin: 0;
          }
          .topframe {
            position: sticky;
            top: 0px;
            left: 0;
            right: 0;
            z-index: 2;
            display: flex;
            justify-content: center;
            height: 50px;
            min-height: 50px;
            width: 100%;
          }
        `}
      </style>
    </>
  )

};

export default BannerClient;
